import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=35c87296&scoped=true"
var script = {}
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=35c87296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c87296",
  null
  
)

export default component.exports